<template>
  <div class="card-form pt-1">
    <PageTable
      ref="table"
      :loading="loading"
      :tableData="tableData"
      @reload="reload"
      @radio-change="(e) => $emit('radio-change', e)"
    />
  </div>
</template>
<script>
import PageTable from './table.vue'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageTable },
  props: { custCode: { type: String, default: '' } },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      if (!this.custCode) return
      this.$api
        .masterCustomerContactsListApi({ custCode: this.custCode })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
